// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
    overflow: hidden;
}

/* Promote the panning layer to a GPU compositor layer while the user pans or
   zooms it (useViewportMotionHint). At rest it is painted at the zoom it shows.
   The child combinators keep the rule off a flow drawn inside a node. */
.react-flow.curio-viewport-moving > .react-flow__renderer > .react-flow__pane > .react-flow__viewport {
    will-change: transform;
}

/* Isolate the ReactFlow renderer so fixed-position overlays don't force repaints */
.react-flow__renderer {
    isolation: isolate;
}

path.react-flow__edge-path {
    stroke-width: 3;
}

path.react-flow__edge-path:hover {
    stroke-width: 9;
}

/* In the notebook view the connections are there to be read: a click on one
   goes through to the page under it, as on React Flow's own inactive edges, so
   none is selected or thickened. One is selected only to be deleted, which
   happens on the canvas (graphEditGates). */
.curio-flow-scroller[data-curio-notebook] .react-flow__edge {
    pointer-events: none;
}

.react-flow__handle {
    background: #888787;
}

/* A node in an expanded scenario wears the scenario's color (#662); the
   canvas view sets --scenario-color on it, a per-node value, not a token. */
.react-flow__node.curio-scenario-member {
    outline: 3px solid var(--scenario-color);
    outline-offset: 3px;
    border-radius: var(--curio-radius-lg);
}

/* The fixed context of the scenario pointed at in the Scenario Catalog
   drawer's In project tab. */
.react-flow__node.curio-scenario-fixed {
    outline: 3px dashed var(--curio-text-secondary);
    outline-offset: 6px;
    border-radius: var(--curio-radius-lg);
}

.react-flow__node.curio-scenario-fixed::before {
    content: "Fixed context";
    position: absolute;
    top: -30px;
    left: 0;
    padding: 0 8px;
    line-height: 20px;
    border-radius: var(--curio-radius-pill);
    background: var(--curio-top-bar-bg);
    color: var(--curio-text-on-dark);
    font-family: var(--curio-font-family);
    font-size: var(--curio-font-size-xs);
    white-space: nowrap;
    pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/MainCanvas.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;;wEAEwE;AACxE;IACI,sBAAsB;AAC1B;;AAEA,mFAAmF;AACnF;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;4CAG4C;AAC5C;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;4EAC4E;AAC5E;IACI,wCAAwC;IACxC,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;6BAC6B;AAC7B;IACI,+CAA+C;IAC/C,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,cAAc;IACd,iBAAiB;IACjB,uCAAuC;IACvC,mCAAmC;IACnC,gCAAgC;IAChC,qCAAqC;IACrC,oCAAoC;IACpC,mBAAmB;IACnB,oBAAoB;AACxB","sourcesContent":["html, body {\n    overflow: hidden;\n}\n\n/* Promote the panning layer to a GPU compositor layer while the user pans or\n   zooms it (useViewportMotionHint). At rest it is painted at the zoom it shows.\n   The child combinators keep the rule off a flow drawn inside a node. */\n.react-flow.curio-viewport-moving > .react-flow__renderer > .react-flow__pane > .react-flow__viewport {\n    will-change: transform;\n}\n\n/* Isolate the ReactFlow renderer so fixed-position overlays don't force repaints */\n.react-flow__renderer {\n    isolation: isolate;\n}\n\npath.react-flow__edge-path {\n    stroke-width: 3;\n}\n\npath.react-flow__edge-path:hover {\n    stroke-width: 9;\n}\n\n/* In the notebook view the connections are there to be read: a click on one\n   goes through to the page under it, as on React Flow's own inactive edges, so\n   none is selected or thickened. One is selected only to be deleted, which\n   happens on the canvas (graphEditGates). */\n.curio-flow-scroller[data-curio-notebook] .react-flow__edge {\n    pointer-events: none;\n}\n\n.react-flow__handle {\n    background: #888787;\n}\n\n/* A node in an expanded scenario wears the scenario's color (#662); the\n   canvas view sets --scenario-color on it, a per-node value, not a token. */\n.react-flow__node.curio-scenario-member {\n    outline: 3px solid var(--scenario-color);\n    outline-offset: 3px;\n    border-radius: var(--curio-radius-lg);\n}\n\n/* The fixed context of the scenario pointed at in the Scenario Catalog\n   drawer's In project tab. */\n.react-flow__node.curio-scenario-fixed {\n    outline: 3px dashed var(--curio-text-secondary);\n    outline-offset: 6px;\n    border-radius: var(--curio-radius-lg);\n}\n\n.react-flow__node.curio-scenario-fixed::before {\n    content: \"Fixed context\";\n    position: absolute;\n    top: -30px;\n    left: 0;\n    padding: 0 8px;\n    line-height: 20px;\n    border-radius: var(--curio-radius-pill);\n    background: var(--curio-top-bar-bg);\n    color: var(--curio-text-on-dark);\n    font-family: var(--curio-font-family);\n    font-size: var(--curio-font-size-xs);\n    white-space: nowrap;\n    pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
